import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { BASE_URL } from '../config/constants';
function ChangePassword() {
	const location = useLocation();
	const navigate = useNavigate();
	const [password, setPassword] = useState('');
	const [resetPasswordHash, setResetPasswordHash] = useState('');
	const [message, setMessage] = useState('');
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState({
		password: '',
	});

	useEffect(() => {
		if (location.search) {
			const params = new URLSearchParams(location.search);
			const hash = params.get('hash');

			if (hash) {
				setResetPasswordHash(hash);
			}
		}
	}, [location]);

	const validatePassword = (password) => {
		const lowerCase = /[a-z]/;
		const upperCase = /[A-Z]/;
		const numbers = /[0-9]/;
		const specialCharacters = /[!@#$%^&*(),.?":{}|<>]/;

		if (!password) {
			return 'Password cannot be empty';
		}
		if (!lowerCase.test(password)) {
			return 'Password must contain at least one lowercase letter';
		}
		if (!upperCase.test(password)) {
			return 'Password must contain at least one uppercase letter';
		}
		if (!numbers.test(password)) {
			return 'Password must contain at least one number';
		}
		if (!specialCharacters.test(password)) {
			return 'Password must contain at least one special character';
		}
		return '';
	};

	const handleConfirm = async () => {
		const passwordError = validatePassword(password);
		if (passwordError) {
			setErrors({ password: passwordError });
			return;
		}

		setErrors({ password: '' });
		setLoading(true);
		setMessage('');
		const baseUrl = BASE_URL;
		try {
			const response = await fetch(`${baseUrl}/api/v1/auth/reset/password`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					password: password,
					hash: resetPasswordHash,
				}),
			});

			if (response.ok) {
				setMessage('Password changed successfully!');
				setTimeout(() => {
					navigate('/login');
				}, 1000);
			} else {
				setMessage('Failed to change password. Please try again.');
			}
		} catch (error) {
			setMessage('An error occurred. Please try again.');
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className='bg-white'>
			<div className='bg-main h-[85vh] flex justify-center items-center'>
				<div className='w-11/12 h-96 md:h-4/6 md:w-1/2 bg-white rounded-xl flex flex-col p-4 justify-center items-center gap-6'>
					<div className='w-28 h-28'>
						<img
							loading='lazy'
							src={'/images/forgetpassword.png'}
							alt='iconImage'
							className=''
						/>
					</div>
					<p className='text-sm md:text-lg text-main w-11/12 text-center'>
						Enter A New Password
					</p>
					<div className='input-group w-full'>
						<input
							className='w-full outline-none p-3 rounded border-[#cedbea] border-[1px] border-solid'
							type='password'
							required
							placeholder='Password'
							value={password}
							onChange={(e) => setPassword(e.target.value)}
						/>
						{errors.password && (
							<p className='text-red-700 text-sm'>{errors.password}</p>
						)}
					</div>
					<button
						onClick={handleConfirm}
						className={`py-2 px-4 md:py-4 md:px-6 rounded ${
							loading ? 'bg-gray-400' : 'bg-secondary'
						}`}>
						{loading ? 'Sending...' : 'Send Password'}
					</button>
					{message && (
						<p
							className={`text-sm ${
								message.includes('successfully')
									? 'text-green-600'
									: 'text-red-700'
							}`}>
							{message}
						</p>
					)}
				</div>
			</div>
		</div>
	);
}

export default ChangePassword;
